export const VENUE_CATEGORIES = [
  "RESTAURANT_DINING",
  "BAR_NIGHTCLUB",
  "EVENT",
  "CATERING",
  "HOTEL",
  "OTHER",
] as const;

export type VenueCategory = (typeof VENUE_CATEGORIES)[number];

export const VENUE_CATEGORY_LABELS: Record<VenueCategory, string> = {
  RESTAURANT_DINING: "Restaurant / dining",
  BAR_NIGHTCLUB: "Bar / nightclub",
  EVENT: "Event venue",
  CATERING: "Catering",
  HOTEL: "Hotel",
  OTHER: "Other",
};

export interface VenueProfile {
  id: string;
  user_id: string;
  business_name: string;
  address: string;
  contact_first_name: string;
  contact_last_name: string;
  contact_role: string | null;
  contact_phone: string | null;
  notes: string | null;
  category: VenueCategory | null;
  logo_url: string | null;
  onboarding_completed_at: string | null;
  rating_avg: number | null;
  /** False when the saved address didn't resolve to lat/lng. Workers can't
   * check in to shifts at a non-geocoded venue, so the venue profile UI
   * surfaces a warning when this is false. */
  geocoded: boolean;
}

export interface UpdateVenueProfilePayload {
  business_name?: string;
  address?: string;
  contact_first_name?: string;
  contact_last_name?: string;
  contact_role?: string;
  contact_phone?: string;
  notes?: string;
  category?: VenueCategory;
}
